import React from 'react';
import {
  Button, Modal, ModalProps,
} from 'react-bootstrap';

interface DisplayModalProps extends ModalProps {
  showCloseButton?: boolean,
  closeButtonFirst?: boolean,
  showXCloseButton?: boolean
}

export function DisplayModal(props: DisplayModalProps) {
  return (
    <Modal
      show={props.show}
      onHide={props.onHide}
      size={props.size}
      aria-labelledby={props.label}
      centered={props.centered}
      backdrop={props.static}
      animation={props.animation}
      className={props.className}
    >
      <Modal.Header closeButton={props.showXCloseButton}>
        <Modal.Title>
          {props.heading}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          {props.data}
        </div>
      </Modal.Body>
      <Modal.Footer>
        {props.closeButtonFirst ? (
          <>
            {props.showCloseButton && (
              <Button
                className="k-button"
                variant="primary"
                onClick={props.onHide}
              >
                {props.buttonCloseText || 'Close'}
              </Button>
            )}
            {props.buttontext ? (
              <Button
                className="k-button"
                variant="primary"
                onClick={props.confirmAction}
                disabled={props.disabled}
              >
                {props.buttontext}
              </Button>
            ) : ''}
          </>
        ) : (
          <>
            {props.buttontext ? (
              <Button
                className="k-button"
                variant="primary"
                onClick={props.confirmAction}
                disabled={props.disabled}
              >
                {props.buttontext}
              </Button>
            ) : ''}
            {props.showCloseButton && (
              <Button
                className="k-button"
                variant="primary"
                onClick={props.onHide}
              >
                {props.buttonCloseText || 'Close'}
              </Button>
            )}
          </>
        )}
      </Modal.Footer>
    </Modal>
  );
}

DisplayModal.defaultProps = {
  showCloseButton: true,
  closeButtonFirst: false,
  showXCloseButton: true
};
